<template>
    <div v-motion :initial="initial" :visible="visible">
        <slot></slot>
    </div>       
</template>

<script setup>


const initial = ref({
    opacity: 0,
    x: 50
});

const visible = ref({
        x: 0,
        opacity: 1,
        transition: {
            type: 'spring',
            stiffness: 250,
            damping: 25,
            mass: 0.5,
        },
    });
</script>